import React, { useEffect } from "react";
import { StyledBookingFlowButton } from
  "../../shared/containers/BookingScheduleContainer/BookingScheduleContainer.style";
import AvatarCustom from "../AvatarCustom/AvatarCustom";
import { MODALS } from "../../config/params";
import { useModal } from "../../context/ModalContext";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import { userActivityLogger } from "../../utils/mixpanel";

interface IDuplicateAccountAlertCard {
  isDuplicateCardShown?: boolean;
  setIsDuplicateCardShown?: (isShown: boolean)=>void;
}

const DuplicateAccountAlertCard: React.FC<IDuplicateAccountAlertCard> =
({ isDuplicateCardShown, setIsDuplicateCardShown }) => {
  const { openModal } = useModal();

  const openContactModal = () => {
    userActivityLogger(MIXPANEL_EVENTS.CONTACT_HOSPITAL_TRIGGERED, {
      referred_from: "wp_cancelled_card_on_dashbaord",
    });
    openModal(MODALS.OVERDUE_CONTACT_MODAL);
  };

  useEffect(()=>{
    if (setIsDuplicateCardShown && !isDuplicateCardShown) {
      userActivityLogger(MIXPANEL_EVENTS.DASHBOARD_DUPLICATE_ACCOUNT_CARD_SHOWN, {});
      setIsDuplicateCardShown(true);
    }
  }, []);


  return (
    <div className="bg-gray-3 px-4 py-6">
      <div className="rounded-xl bg-white flex flex-col p-4 pt-3 gap-4 shadow-lg">
        <div className="flex gap-3 w-full items-center">
          <div>
            <AvatarCustom
              width={90}
              height={90}
              image={"assets/icons/account-alert.png"}
              name="Account_Alert_Image"
            />
          </div>
          <div>
            <div className="font-semibold">
              Account Confirmation Needed
            </div>
            <div className="text-sm text-justify">
            We have multiple accounts for you in our system. To avoid any confusion and ensure accurate records,
            please call your home hospital to confirm the correct account.
            </div>
          </div>
        </div>
        <div>
          <StyledBookingFlowButton
            disabled={false}
            fullWidth
            color="primary"
            size="small"
            onClick={openContactModal}
          >
           Contact Hospital
          </StyledBookingFlowButton>
        </div>
      </div>
    </div>

  );
};

export default DuplicateAccountAlertCard;
